import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { GET_COMMUNITIES } from "./apiRoutes";

const mutateGoLiveCommunity = async ({ communityId }: { communityId: FieldValues }) => {
  return await axiosAuth.post(`${GET_COMMUNITIES}/${communityId}/go-live`);
};

const useGoLiveCommunityMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      communityId: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateGoLiveCommunity,
    ...queryParams,
  });

export default useGoLiveCommunityMutation;
